import React from 'react'
import { Field, WatchField } from '../../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import FontAwesome from 'react-fontawesome'
import {
  calculateHoursBetween,
  convertIntToState_ws
} from '../../../utils/openForWork.utils'
import SumField from '../../invoice/sumField.component'
import { GenericNumberInput } from '../../../utils/numberFormat'
import { calculateTotalSum } from '../../../utils/invoice.utils'
import { toMinutes } from '../../../containers/validate'

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(1),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  margin: {
    margin: theme.spacing(1)
  },
  tablecell: {
    [theme.breakpoints.up(1200)]: {
      paddingInline: '5px'
    }
  }
})

const ShiftDateRow = ({
  index,
  remove,
  classes,
  date,
  control,
  work_starts,
  work_ends,
  totalHour,
  t,
  isEditWorkshift,
  status_entrepreneur,
  // hourly_rate,
  setValue,
  amount,
  totalAmount,
  selectedOfferTo,
  getValues,
  watchRowsData,
  clearErrors
}) => {
  const rowIndex = index
  const fieldsToWatch = [totalHour, amount, work_starts, work_ends]
  const formValues = getValues()

  function removeRow() {
    remove(index)
  }

  const disabledShiftRow =
    status_entrepreneur === 0 ||
    status_entrepreneur === undefined ||
    status_entrepreneur === null
      ? false
      : true

  const timeChanges = () => {
    watchRowsData.forEach((row) => {
      if (toMinutes(row.shiftstarttime) < toMinutes(row.shiftendtime)) {
        clearErrors(`dateRows.${rowIndex}.shiftstarttime`)
        clearErrors(`dateRows.${rowIndex}.shiftendtime`)
      }
    })
  }

  return (
    <TableRow>
      <TableCell className={classes.tablecell} style={{ minWidth: '140px' }}>
        <Field
          className={classNames(classes.textField, classes.resize)}
          name={date}
          inputType="datepicker"
          control={control}
          minDate={new Date()}
          showCalendarIcon
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
          disabled={disabledShiftRow}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '85px' }}>
        <Field
          className={classNames(classes.resize)}
          name={work_starts}
          inputType="timepicker-selection"
          control={control}
          disabled={disabledShiftRow}
          updateStyle={{
            marginTop: '8px',
            color: disabledShiftRow ? '#00000061' : ''
          }}
          onChange={timeChanges}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '85px' }}>
        <Field
          className={classNames(classes.resize)}
          name={work_ends}
          inputType="timepicker-selection"
          control={control}
          disabled={disabledShiftRow}
          updateStyle={{
            marginTop: '8px',
            color: disabledShiftRow ? '#00000061' : ''
          }}
          onChange={timeChanges}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '75px' }}>
        <WatchField fields={fieldsToWatch} control={control}>
          {(fields) => (
            <SumField
              name={totalHour}
              setValue={setValue}
              className={classNames(classes.textField, classes.resize)}
              control={control}
              watchValue={calculateHoursBetween(
                fields[work_starts],
                fields[work_ends]
              )}
              isTotalHours={true}
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell
        className={classes.tablecell}
        style={{
          fontSize: '13px',
          color: '#85868D',
          width:
            selectedOfferTo?.salary_model === 'Hourly rate' ||
            (isEditWorkshift && formValues.salary_model === 'Hourly rate')
              ? '75px'
              : '150px'
        }}
      >
        {selectedOfferTo?.salary_model === 'Hourly rate' ||
        (isEditWorkshift && formValues.salary_model === 'Hourly rate') ? (
          <Field
            name={amount}
            inputType="textfield"
            control={control}
            className={classNames(classes.textField, classes.resize)}
            inputComponent={GenericNumberInput}
            helperTextStyle={{ marginTop: '0px', height: '0px' }}
            disabled={disabledShiftRow}
          />
        ) : (
          t('employer.workshifts.fld9_note')
        )}
      </TableCell>
      {selectedOfferTo?.salary_model === 'Commission' ||
      (isEditWorkshift && formValues.salary_model === 'Commission') ? (
        <TableCell className={classes.tablecell} style={{ width: '105px' }}>
          <Field
            name={amount}
            inputType="textfield"
            control={control}
            className={classNames(classes.textField, classes.resize)}
            inputComponent={GenericNumberInput}
            helperTextStyle={{ marginTop: '0px', height: '0px' }}
            disabled={disabledShiftRow}
          />
        </TableCell>
      ) : null}
      <TableCell className={classes.tablecell} style={{ width: '100px' }}>
        <WatchField fields={fieldsToWatch} control={control}>
          {(fields) => (
            <SumField
              name={totalAmount}
              setValue={setValue}
              className={classNames(classes.textField, classes.resize)}
              control={control}
              watchValue={calculateTotalSum(
                false,
                fields[totalHour],
                fields[amount],
                0,
                false,
                false
              )}
            />
          )}
        </WatchField>
      </TableCell>
      {isEditWorkshift ? (
        <TableCell
          className={classes.tablecell}
          style={{ fontSize: '13px', color: '#85868D' }}
        >
          {status_entrepreneur === 1
            ? convertIntToState_ws(5)
            : convertIntToState_ws(status_entrepreneur)}
        </TableCell>
      ) : (
        <TableCell>
          <IconButton
            aria-label="Delete"
            className={classes.margin}
            onClick={removeRow}
            key={index}
          >
            <FontAwesome name="window-close" style={{ color: '#F67131' }} />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  )
}

ShiftDateRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ShiftDateRow)
